<template>
  <NewHouseLayout :breadcrumbs="[{ name: '登录失败' }]">
    <div class="nh-card">
      <div class="nh-error-icon">
        <span class="icon-circle">
          <span class="icon-x">×</span>
        </span>
      </div>

      <h2 class="nh-error-title">登录失败</h2>
      <p class="nh-error-desc">江西可信身份认证系统单点登录失败，请稍后再试或联系系统管理员。</p>

      <div class="nh-error-actions">
        <el-button type="danger" size="large" class="nh-btn nh-btn-retry" @click="handleRetry">
          重新登录
        </el-button>
      </div>
    </div>
  </NewHouseLayout>
</template>

<script setup>
import NewHouseLayout from './layout.vue';

const handleRetry = () => {
  // 跳江西可信身份认证系统登录，登录成功回到本应用
  localStorage.removeItem('token');
  window.location.href =
    'https://gftjis.jxzwfww.gov.cn/jisgft/front/login.do?uuid=SFH1rp0OLaU0&gotourl=https://admin.wnzhzj.com/s-pages/';
};
</script>

<style lang="scss" scoped>
.nh-card {
  max-width: 960px;
  margin: 32px auto 24px;
  background: #ffffff;
  border-radius: 8px;
  padding: 48px 40px 40px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  text-align: center;
}

.nh-error-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.icon-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #fdecec;
  border: 2px solid #bd1a2d;
  color: #bd1a2d;
  font-size: 36px;
  line-height: 1;
}

.icon-x {
  font-weight: 600;
  position: relative;
  top: -4px;
}

.nh-error-title {
  font-size: 22px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 12px;
}

.nh-error-desc {
  font-size: 15px;
  color: #4a4a4a;
  line-height: 1.8;
  margin: 0 0 28px;
}

.nh-error-actions {
  display: flex;
  justify-content: center;
  margin-bottom: 28px;
}

.nh-btn {
  width: 200px;
  height: 44px;
  font-size: 16px;
}

.nh-btn-retry {
  background: #bd1a2d;
  border-color: #bd1a2d;
}
</style>
